export const singlePurchaseListConstants = {
    ADD_SINGLE_PURCHASE_TO_LIST: 'ADD_SINGLE_PURCHASE_TO_LIST',
    CLEAR_SINGLE_PURCHASE_LIST: 'CLEAR_SINGLE_PURCHASE_LIST',
    SET_FORM_START_EVENT_EMITTED: 'SET_SINGLE_PURCHASE_FORM_START_EVENT_EMITTED',
    CLEAR_FORM_START_EVENT_EMITTED: 'CLEAR_SINGLE_PURCHASE_FORM_START_EVENT_EMITTED',
}